import { create } from 'zustand';
import { Address } from '../interface/interface';

interface OrderCreateRequest{
  variantId: string;
  quantity: number;
  addressId: string;
  notes?: string;
  amountPaid?: number;
  productName?: string;
}

interface OrderDataStore {
  email: string;
  address?: Address;
  orders: OrderCreateRequest[];
}

let settings: OrderDataStore = {
  email: '',
  address: undefined,
  orders: []
}

export interface OrderDataState {
  settings: OrderDataStore;
  actions: {
    addOrder: (order: OrderCreateRequest) => void;
    setEmail: (email: string) => void;
    clearOrders: () => void;
    removeOrder?: (variantId: string, addressId: string) => void;
    setAddress?: (address: Address) => void;
  };
}

export const useOrderDataStore = create<OrderDataState>((set, get) => ({
  settings,
  actions: {
    removeOrder: (variantId: string, addressId: string) => {
      set((state) => ({
        settings: {
          ...state.settings,
          orders: state.settings.orders.filter(
            (order) => order.variantId !== variantId || order.addressId !== addressId
          ),
        }
      }));
    },
    addOrder: (order: OrderCreateRequest) => {
      // Check if the order already exists
      const existingOrderIndex = get().settings.orders.findIndex(
        (o) => o.variantId === order.variantId && o.addressId === order.addressId
      );
      // If it exists, update the quantity
      if (existingOrderIndex !== -1) {
        set((state) => {
          const updatedOrders = [...state.settings.orders];
          updatedOrders[existingOrderIndex].quantity = order.quantity;
          return {
            settings: {
              ...state.settings,
              orders: updatedOrders,
            }
          };
        });
        return;
      }else{
        set((state) => ({
          settings: {
            ...state.settings,
            orders: [...state.settings.orders, order],
          }
        }));
      }


    },
    setEmail: (email: string) => {
      set((state) => ({
        settings: {
          ...state.settings,
          email: email,
        }
      }));
    },
    clearOrders: () => {
      set((state) => ({
        settings: {
          ...state.settings,
          orders: [],
        }
      }));
    },
    setAddress: (address: Address) => {
      set((state) => ({
        settings: {
          ...state.settings,
          address: address,
        }
      }));
    }


  }
}));
